import { ApolloProvider } from "@apollo/react-hooks";
import { ThemeProvider } from "@mui/material/styles";
import { PostHogProvider } from "configs/Posthog.configs";
import VwoIntegration from "configs/VWO.configs";
import Zendesk, { ZendeskAPI } from "configs/Zendesk.configs";
import { UserAppContextProvider } from "contexts";
import React, { Fragment } from "react";
import "react-toastify/dist/ReactToastify.css";
import useRouteElement from "routes/useRouteElement";
import { createApolloClient } from "scripts/apollo";
import "styles/scss/style.scss";
import theme from "styles/theme";
// import { ProtectedRoute } from "../Layouts/ProtectedRoute";

const apolloClient = createApolloClient();
const ZENDESK_KEY = "06a51951-870b-4b7d-9e8c-b47a1c99a844";

const UserApp = () => {
    const routeElement = useRouteElement()

    const handleLoaded = () => {
        // HideZendeskChat()

        ZendeskAPI("messenger:on", "open", () => {
            console.log("Zendesk messenger opened");
        });
    };

    return (
        <Fragment>
            {apolloClient && (
                <ApolloProvider client={apolloClient}>
                    <UserAppContextProvider apolloClient={apolloClient}>
                        <ThemeProvider theme={theme}>
                            <PostHogProvider>
                                {routeElement}
                            </PostHogProvider>
                        </ThemeProvider>
                    </UserAppContextProvider>
                    <Zendesk
                        defer
                        zendeskKey={ZENDESK_KEY}
                        onLoaded={handleLoaded}
                    />
                    <VwoIntegration />
                </ApolloProvider>
            )}
        </Fragment>
    );
};

export default UserApp;
